/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamPhotoIcon16Solid = forwardRef('TechCamPhotoIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 8.25a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 3A2.5 2.5 0 0 0 1 5.5v6A2.5 2.5 0 0 0 3.5 14h9a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 12.5 3h-1l-.585-1.17A1.5 1.5 0 0 0 9.573 1H6.427a1.5 1.5 0 0 0-1.342.83L4.5 3h-1ZM8 4.75a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" })));
});
